export default __webpack_public_path__ + "static/media/discount.7ca5b422.png";